
const DuiDetails = ({ duiDetail }) => {
  return (
    <>
      <section className="dui-details mb-3 mb-md-5">
        <div className="container">
          <div className="row">
            {duiDetail && (
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div dangerouslySetInnerHTML={{ __html: duiDetail }}></div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default DuiDetails;
